<template>
    <div>
        <v-row>
            <v-col cols="1">
                <v-btn 
                color="primary" 
                dark 
                class="mb-2"
                @click="addItemHandler"
                >
                +
                </v-btn>
            </v-col>
            <v-col cols="2">
                <v-text-field
                v-model="search"
                append-icon="search"
                style="width: 300px"
                class="pr-5 pt-3"
                hide-details
                ></v-text-field>
            </v-col>
        </v-row>
        <v-dialog v-model="reportDialog" max-width="1000px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{$t('setupbaitulmal.statutoryreportgroupitem')}}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="6" sm="6" md="6">
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('setuppayitem.payitem')"
                                    type="text"
                                    :items="payitemList"
                                    v-model="selections.payitemid"
                                    @change="changePayItemHandler(selections.payitemid)"
                                    @input="changePayItemHandler(selections.payitemid)"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="6" sm="6" md="6" >
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('setupbaitulmal.ea')"
                                    type="text"
                                    :items="eaList"
                                    v-model="selections.eaid"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" sm="6" md="6 mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('setupbaitulmal.tp1')"
                                    type="text"
                                    :items="tp1List"
                                    v-model="selections.tp1id"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="6" sm="6" md="6 mt-n8" >
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('setupbaitulmal.cp22')"
                                    type="text"
                                    :items="cp22List"
                                    v-model="selections.cp22id"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="6 mt-n8" >
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('setupbaitulmal.cp22a')"
                                    type="text"
                                    :items="cp22aList"
                                    v-model="selections.cp22aid"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="6 mt-n8" >
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('setupbaitulmal.cp22b')"
                                    type="text"
                                    :items="cp22bList"
                                    v-model="selections.cp22bid"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row> 
                            <v-col cols="12" sm="6" md="6 mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('setupbaitulmal.cp21')"
                                    type="text"
                                    :items="cp21List"
                                    v-model="selections.cp21id"
                                    dense
                                    clearable
                                ></v-autocomplete>
                            </v-col>
                            <!-- <v-col cols="12" sm="6" md="6 mt-n8" >
                                <v-text-field
                                    outlined
                                    :label="this.$t('setupbaitulmal.payslip')"
                                    type="text"
                                    v-model="selections.payslip"
                                    dense
                                    clearable
                                ></v-text-field>
                            </v-col> -->
                        </v-row>
                        <v-row>
                            <v-col cols="6" sm="6" md="6 mt-n8">
                                <v-text-field
                                    outlined
                                    :label="this.$t('setupclaim.payitemdescription')"
                                    type="text"
                                    v-model="selections.payitemdesc"
                                    dense
                                    background-color="#ffeab2"
                                    readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="6 mt-n8" >
                            <v-text-field
                                    outlined
                                    :label="this.$t('setupbaitulmal.payitemtypedesc')"
                                    type="text"
                                    v-model="selections.payitemtypedesc"
                                    dense
                                    background-color="#ffeab2"
                                    readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{errMsg}}</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeReportSetup">{{$t('button.cancel')}}</v-btn>
                    <v-btn color="green darken-1" text @click="saveReportSetup">{{$t('button.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> 
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            :search="search"
            class="elavation-1"
            fixed-header
            :sort-by="['code']"
        >
            <template v-slot:[`item.action`]="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="modifyItemHandler(item)"
                >
                    mdi-pen
                </v-icon>
                <v-icon
                    small
                    class="ml-3 mr-2"
                    @click="requestDelete(item)"
                >
                    mdi-delete
                </v-icon>            
            </template>
        </v-data-table>
        <div v-if="isConfirm">
            <app-confirm
                v-bind:parentObject="{
                    pageTitleValue: this.confirmTitleValue,
                    isConfirm: this.isConfirm,
                }"
                v-on:confirm="onConfirmDelete"
                v-on:cancelConfirm="onCancelDelete"
            />
        </div>
    </div>
</template>

<script>
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
    props: {
        parentObject: Object
    },
    components: {
        "app-confirm": ConfirmDialog,
    },

    data() {
        return {
            reportDialog: false,

            detailItem: this.parentObject.detailItem,
            formDataId: this.parentObject.formDataId,//this is the parent form ID
            selections: {
                id: null,
                statutoryreportsetupid: null,
                payitemid: null,
                eaid: null,
                tp1id: null,
                cp22id: null,
                cp22aid: null,
                cp22bid: null,
                cp21id: null,
                payslip: null,
                payitemtypedesc: null,
                payitemdesc: null,
                userid: this.$store.getters.userId,
                stamp: null,
            },

            //arrays to store various data objects from db 
            payitems: [],
            payitemList: [],

            // Main list
            reportsetups: [], 
            //Separate to each type list
            tp1List: [],
            eaList: [],
            cp22List: [],
            cp22aList: [],
            cp22bList: [],
            cp21List: [],
            

            search: '',

            //error msg and dialog, check for duplicates vars
            isErr: false,
            errMsg: '',


            isConfirm: false,
            confirmTitleValue: '',
            itemToDelete: null, // track which item you want to delete
        }
    },

    methods: {
        addItemHandler() {
            this.resetSelections();
            this.reportDialog = true;
        },

        modifyItemHandler(item) {
            this.selections.id =item.id;
            this.selections.statutoryreportsetupid =item.statutoryreportsetupid;
            this.selections.payitemid =item.payitemid;
            this.selections.eaid =item.eaid;
            this.selections.tp1id =item.tp1id;
            this.selections.cp22id =item.cp22id;
            this.selections.cp22aid =item.cp22aid;
            this.selections.cp22bid =item.cp22bid;
            this.selections.cp21id =item.cp21id;
            this.selections.payslip =item.payslip;
            this.selections.payitemtypedesc =item.payitemtypedesc;
            this.selections.payitemdesc =item.payitemdesc;
            this.selections.userid = this.$store.getters.userId;//always assign current user
            this.selections.stamp =item.stamp;

            if(this.selections.statutoryreportsetupid == null || this.selections.statutoryreportsetupid == 0 || this.selections.id == null || this.selections.id == 0){
                this.$emit('error', { isErr: true, errMsg: "Invalid ID, Cannot modify" });
                return;
            }
            this.reportDialog = true;
        },

        requestDelete(item) {//open confirm dialog for delete

            // save item reference
            this.itemToDelete = item;

            // open confirm dialog
            this.isConfirm = true;
            this.confirmTitleValue = item.payitemcode || "Unknown Item Name"
        },

        async onConfirmDelete() {
            if (!this.itemToDelete) return;

            await this.deleteItemHandler(this.itemToDelete);

            // close dialog
            this.isConfirm = false;
            this.itemToDelete = null;
        },

        onCancelDelete() {
            this.isConfirm = false;
            this.itemToDelete = null;
        },

        async deleteItemHandler(item) {
            if(item.id == null || item.id == 0){
                this.$emit('error', { isErr: true, errMsg: "Invalid ID, Please try again" });
                return;
            }
            try {
                const res = await this.$store.dispatch('delete', { 
                    url: `/statutoryreportsetupD/${item.id}`
                });

                if (res.data.error) {
                    this.$emit('error', { 
                        isErr: true,
                        errMsg: res.data.error || "Error deleting record, please try again"
                    });
                    return;
                }
                if (!res.data.id) {
                    this.$emit('error', {
                        isErr: true,
                        errMsg: "Record not found or not saved, please try again"
                    });
                    return;
                }
                
                // ✅ emit + close only after success                
                this.$emit('reload');//Reload the detail from parent side
                this.resetSelections();
            } catch (err) {
                this.$emit('error', {
                    isErr: true,
                    errMsg: err.message || err
                });
                return;
            }
        },

        closeReportSetup() {
            this.reportDialog = false;
            this.isErr = false;
            this.errMsg = '';
            // reset the form fields
            this.resetSelections();
        },

        async saveReportSetup() {
            console.log("save clicked");
            if (this.selections.payitemid == null) {
                this.$emit('error', { 
                    isErr: true, 
                    errMsg: this.$t('setupbaitulmal.statmsg1') 
                });
                return;
            }

            if (this.selections.statutoryreportsetupid == null || this.selections.statutoryreportsetupid == 0) {
                this.$emit('error', { 
                    isErr: true,
                    errMsg: "Invalid Statutory Report Setup ID, Cannot save"
                });
                return;
            }
            
            try {
                const res = await this.$store.dispatch('put', { 
                    url: "/statutoryreportsetupD/", 
                    payload: this.selections 
                });

                if (res.data.error) {
                    this.$emit('error', { 
                        isErr: true,
                        errMsg: res.data.error
                    });
                    return;
                }
                if (!res.data.id) {
                    this.$emit('error', {
                        isErr: true,
                        errMsg: "Record not found or not saved, please try again"
                    });
                    return;
                }
                
                // ✅ emit + close only after success
                this.$emit('input');
                this.reportDialog = false;
                this.resetSelections();
            } catch (err) {
                this.$emit('error', {
                    isErr: true,
                    errMsg: err.message || err
                });
                return;
            }
        },

        resetSelections() {
            this.selections.id =null;
            this.selections.statutoryreportsetupid = this.formDataId; //assign the parent form ID here
            this.selections.payitemid =null;
            this.selections.eaid =null;
            this.selections.tp1id =null;
            this.selections.cp22id =null;
            this.selections.cp22aid =null;
            this.selections.cp22bid =null;
            this.selections.cp21id =null;
            this.selections.payslip =null;
            this.selections.payitemtypedesc =null;
            this.selections.payitemdesc =null;
            this.selections.userid = this.$store.getters.userId;//always assign current user
            this.selections.stamp =null; 
        },

        loadPayItem() {
            const vm = this;

            this.$store.dispatch('get', {url: '/payitems/all'})
            .then (res => {
                vm.payitems = res.data.rec;

                for (let i = 0; i < vm.payitems.length; i++) {
                    vm.payitemList.push(
                        {   
                            payitemtypedesc: vm.payitems[i].payitemtypedesc,
                            payitemdesc: vm.payitems[i].payitemdesc,
                            text: vm.payitems[i].payitemcode,
                            value: vm.payitems[i].id
                        }
                    )
                }
            });
        },

        loadReportSetupTypesHandler() {
            const vm = this;

            this.$store.dispatch('get', {url: '/reportsetup/all'})
            .then (res => {
                vm.reportsetups = res.data.rec;
                for (let i = 0; i < vm.reportsetups.length; i++) {
                    if (vm.reportsetups[i].formtype == 'EA') {
                         vm.eaList.push(
                            {
                                text: vm.reportsetups[i].fieldid + " - " + vm.reportsetups[i].fielddesc,
                                value: vm.reportsetups[i].id
                            }
                        )
                    }


                    if (vm.reportsetups[i].formtype == 'TP1') {
                         vm.tp1List.push(
                            {
                                text: vm.reportsetups[i].fieldid + " - " + vm.reportsetups[i].fielddesc,
                                value: vm.reportsetups[i].id
                            }
                        )
                    }

                    if (vm.reportsetups[i].formtype == 'CP22') {
                         vm.cp22List.push(
                            {
                                text: vm.reportsetups[i].fieldid + " - " + vm.reportsetups[i].fielddesc ,
                                value: vm.reportsetups[i].id
                            }
                        )
                    }

                    if (vm.reportsetups[i].formtype == 'CP22A') {
                        vm.cp22aList.push(
                            {
                                text: vm.reportsetups[i].fieldid + " - " + vm.reportsetups[i].fielddesc ,
                                value: vm.reportsetups[i].id
                            }
                        )
                    }
                    if (vm.reportsetups[i].formtype == 'CP22B') {
                        vm.cp22bList.push(
                            {
                                text: vm.reportsetups[i].fieldid + " - " + vm.reportsetups[i].fielddesc ,
                                value: vm.reportsetups[i].id
                            }
                        )
                    }

                    if (vm.reportsetups[i].formtype == 'CP21') {
                         vm.cp21List.push(
                            {
                                text: vm.reportsetups[i].fieldid + " - " + vm.reportsetups[i].fielddesc ,
                                value: vm.reportsetups[i].id
                            }
                        )
                    }
                }
            });
        },

        // handlers for change event pay item
        changePayItemHandler(id) {
            let item = this.payitems.find(item => item.id == id)
        
            this.selections.payitemdesc = item.payitemdesc;
            this.selections.payitemtypedesc = item.payitemtypedesc;

        },
    },

    mounted() {
        try {
            this.loadPayItem();
            this.loadReportSetupTypesHandler();
            if(this.parentObject.formDataId == null && this.parentObject.formDataId == 0){
                this.$emit('error', { isErr: true, errMsg: "Invalid Form Data ID, Cannot load details" });
            }
        } catch (error) {
            this.$emit('error', { isErr: true, errMsg: "Something Went wrong in the CRUD mounted" });
        }
    }
}
</script>